import type {
  PreviewCabinetPiecesRequest,
  PreviewCabinetRequest,
  PreviewCountertopRequest,
  PreviewDrawerRequest,
  PreviewElementRequest,
  PreviewLightingRequest,
  PreviewPanelRequest,
  PreviewResponse,
  PricingConstantsDto,
} from '@kreart/shared';
import { api } from '@/lib/api';

export const pricingApi = {
  /** Engine multipliers the UI quotes back when explaining a price. */
  constants: () => api.get<PricingConstantsDto>('/pricing/constants'),
  previewPanel: (body: PreviewPanelRequest) =>
    api.post<PreviewResponse>('/pricing/panel/preview', body),
  previewCountertop: (body: PreviewCountertopRequest) =>
    api.post<PreviewResponse>('/pricing/countertop/preview', body),
  previewDrawer: (body: PreviewDrawerRequest) =>
    api.post<PreviewResponse>('/pricing/drawer/preview', body),
  previewElement: (body: PreviewElementRequest) =>
    api.post<PreviewResponse>('/pricing/element/preview', body),
  previewLighting: (body: PreviewLightingRequest) =>
    api.post<PreviewResponse>('/pricing/lighting/preview', body),
  previewCabinet: (body: PreviewCabinetRequest) =>
    api.post<PreviewResponse>('/pricing/cabinet/preview', body),
  previewCabinetPieces: (body: PreviewCabinetPiecesRequest) =>
    api.post<PreviewResponse>('/pricing/cabinet-pieces/preview', body),
};
